import {
  Container,
  HeadingText,
  Text,
  InnerContainer,
  BulletPoint,
  InternalSubHeading,
  SubHeading
} from './T&C.style';

export const TermsandConditions = () => {
  return (
    <Container>
      <InnerContainer>
        <HeadingText>RoundPe Terms of Service</HeadingText>
        <SubHeading>Last Updated: July 10, 2022</SubHeading>
        <Text>
          Round Finance Inc. (<b>“Round Finance”</b> <b>“RoundPe”</b>{' '}
          <b>“Round”</b> or <b>“we”</b> or <b>“us”</b> or  <b>“our”</b>) makes
          available to users that are merchants certain software services
          accessible via a mobile device or web application, including RoundPe
          (the <b>“RoundPe”</b>  or <b>“App”</b>). The RoundPe Application
          enables users to (i) accept cryptocurrency as a payment method for
          goods and services; (ii) self custody digital assets; (iii) access
          reporting and invoicing capabilities; and (iv) additional
          functionality as Round Finance Inc. may add to the App from time to
          time (collectively the <b>“Services”</b>). Round Finance Inc.
          developed these Terms of Service (these <b>“Terms”</b>) to describe
          the terms that govern your use of all versions of the RoundPe
          Application. These terms and additional information about the RoundPe
          Application can be found on the RoundPe website located at
          (https://www.roundpe.com/) (the <b>“Site”</b>).
        </Text>
        <SubHeading>Agreement to Terms</SubHeading>
        <Text>
          By clicking “I Agree” or by accessing the RoundPe Application or using
          any or all of the Services, you agree to be bound by these Terms. If
          you don’t agree to be bound by these Terms, you may not access or use
          the Services.
        </Text>
        <SubHeading>Privacy Policy</SubHeading>
        <Text>
          Please refer to our RoundPe Privacy Policy for information on how we
          collect, use and disclose information from our users. You acknowledge
          and agree that your use of the Services is subject to, and that we can
          collect, use and/or disclose your information (including any personal
          data you provide to us) in accordance with our Privacy Policy.
        </Text>
        <SubHeading>Changes to Terms or Services</SubHeading>
        <Text>
          We may modify the Terms at any time at our sole discretion. If we do
          so, we’ll let you know either by posting the modified Terms on the
          Site, by providing you a notice through the App, or through other
          methods of communication which we deem reasonable. The modified Terms
          will be effective at the time they are either posted on the Site,
          provided as a notice through the App, or through other methods of
          communication which we deem reasonable, whichever is earliest, unless
          we indicate otherwise. It’s important that you review the Terms
          whenever we modify them because if you continue to use the Services
          after we have modified the Terms, you are agreeing to be bound by the
          modified Terms. If you don’t agree to be bound by the modified Terms,
          then you may not use the Services. Because our Services are evolving
          over time we may change or discontinue all or any part of the
          Services, at any time and without notice, at our sole discretion.
        </Text>
        <Text>
          <b>
            ARBITRATION NOTICE: THESE TERMS CONTAIN AN ARBITRATION CLAUSE FOR
            USERS IN CERTAIN JURISDICTIONS. IF YOU ARE A USER LOCATED IN THE
            UNITED STATES OR CANADA YOU AGREE THAT DISPUTES BETWEEN YOU AND
            ROUNDPE WILL BE RESOLVED BY BINDING, INDIVIDUAL ARBITRATION IN THE
            UNITED STATES OR CANADA AS APPLICABLE, AND YOU ARE WAIVING YOUR
            RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE AS A PLAINTIFF OR CLASS
            MEMBER IN ANY PURPORTED CLASS ACTION OR REPRESENTATIVE PROCEEDING.
          </b>
        </Text>
        <SubHeading>Who May Use the Services</SubHeading>
        <SubHeading>Eligibility</SubHeading>
        <Text>
          You may only use the Services if you are 18 years or older and are not
          barred from using the Services under applicable law.
        </Text>
        <SubHeading>Registration and Your Information</SubHeading>
        <Text>
          If you want to use the Services you’ll have to create an account (
          <b>“Account”</b>) via the App. You agree that you won’t disclose your
          Account credentials to anyone and you’ll notify us immediately of any
          unauthorized use of your Account. You’re responsible for all
          activities that occur under your Account, or are otherwise referable
          to your Account credentials, whether or not you know about them. We
          reserve the right to suspend or terminate your Account if you provide
          inaccurate, untrue, or incomplete information, or if you fail to
          comply with the Account registration requirements or these terms.
        </Text>
        <Text>
          You are solely responsible for the retention and security of your
          twelve word recovery phrase (<b>“Recovery Phrase”</b>). Your Recovery
          Phrase is the only way to access the cryptocurrency associated with
          your Account. Anyone that has access to your Recovery Phrase can
          access your cryptocurrency. 
          <b>
            If you lose your Recovery Phrase, you will not be able to access
            your cryptocurrency. You acknowledge Round Finance Inc. does not
            store and is not responsible in any way for the security of your
            Recovery Phrase and you agree to hold Round Finance Inc. and/or
            RoundPe harmless and that Round Finance Inc. and/or RoundPe shall
            not be liable in any way in the event you lose your Recovery Phrase
            and cannot access your cryptocurrency.
          </b>
        </Text>
        <SubHeading>Feedback</SubHeading>
        <Text>
          We welcome feedback, comments, ideas, and suggestions for improvements
          to the Services (<b>“Feedback”</b>). You can submit Feedback by
          contacting us at support@roundpe.com . You grant to us a
          non-exclusive, worldwide, perpetual, irrevocable, fully-paid,
          royalty-free, sublicensable and transferable license under any and all
          intellectual property rights that you own or control to use, copy,
          modify, create derivative works based upon and to otherwise exploit
          the Feedback for any purpose.
        </Text>
        <SubHeading>Content Ownership, Responsibility and Removal</SubHeading>
        <Text>
          For purposes of these Terms: (i) <b>“Content”</b> means text,
          graphics, images, music, software, audio, video, works of authorship
          of any kind, and information or other materials that are posted,
          generated, provided or otherwise made available through the Services;
          and (ii) <b>“User Content”</b> means any content that Account holders
          (including you) make available through the Services.
        </Text>
        <Text>
          We do not claim any ownership rights in any User Content and nothing
          in these Terms will be deemed to restrict any rights that you may have
          to use and exploit your User Content unless explicitly indicated in
          the Terms.
        </Text>
        <Text>
          Subject to the foregoing, RoundPe and its licensors exclusively own
          all right, title and interest in and to the Services and Content,
          including all associated intellectual property rights. You acknowledge
          that the Services and Content are protected by copyright, trademark,
          and other laws of the United States and foreign countries. You agree
          not to remove, alter or obscure any copyright, trademark, service mark
          or other proprietary rights notices incorporated in or accompanying
          the Services or Content.
        </Text>
        <SubHeading>Rights in User Content Granted by You</SubHeading>
        <Text>
          In order to operate and provide our Services, you grant us a
          worldwide, non-exclusive, royalty-free, sublicensable, and
          transferable license to use, copy, distribute, create derivative works
          of, display, and perform the User Content that you upload, submit,
          store, send, or receive on the App or through our Services. The rights
          you grant in this license are for the limited purpose of operating and
          providing our Services. Additional information about your privacy and
          how we use User Content is available in the Privacy Policy.
        </Text>
        <Text>
          You warrant and represent that you have the right and authority to
          submit your User Content and that the User Content or any part thereof
          does not infringe the intellectual property rights or any other rights
          of any third party.
        </Text>
        <Text>
          You acknowledge that, in certain instances, where you have removed
          your User Content by specifically deleting it, some of your User
          Content (such as posts or comments you make) may not be completely
          removed and copies of your User Content may continue to exist on the
          Services. We are not responsible or liable for the removal or deletion
          of (or the failure to remove or delete) any of your User Content.
        </Text>
        <SubHeading>Rights in Content Granted by Round Finance Inc.</SubHeading>
        <Text>
          Subject to your compliance with these Terms, we grant you a limited,
          non-exclusive, non-transferable, non-sublicensable license to
          download, view, copy, display and print the Content solely in
          connection with your permitted use of the Services.
        </Text>
        <SubHeading>
          Rights in App, Site and Services Granted by Round Finance Inc.
        </SubHeading>
        <Text>
          The App, Site and Services are proprietary to Round Finance Inc. and
          its licensors and must not be used other than strictly in accordance
          with these Terms. Round Finance Inc. grants to you a limited,
          non-exclusive, non-transferable, non-sublicensable right to use the
          App and Site for the purposes of accessing and using the Services in
          accordance with these Terms.
        </Text>
        <SubHeading>Fees</SubHeading>
        <Text>
          We may charge fee(s) for some or part of the Services we make
          available to you. All applicable transaction fee(s) are set forth in
          the applicable fee schedule set forth in<b> Exhibit A</b>. We reserve
          the right to change those fee(s) at our discretion with notice. We
          also reserve the right to vary or waive the amount of and terms for
          fee(s) that apply to user(s) of the Services at our discretion in
          accordance with the terms of our agreement(s) with them.
        </Text>
        <Text>
          In addition to the fee(s) specified in <b>Exhibit A</b>, you may incur
          charges from third parties for use of linked services. You may also be
          charged fees by Round Finance Inc. if you elect to link the RoundPe
          Application to your RoundPe account and transfer and convert
          cryptocurrency in your RoundPe account. Third party fee(s) are not
          charged by RoundPe and are not paid to Round Finance Inc. Please note
          that we shall not refund any Transaction Fee that arises as a result
          of you refunding Transactions (as such terms are defined in Exhibit
          A).
        </Text>
        <SubHeading>
          Acceptable Use and Round Finance Inc’s Enforcement Rights
        </SubHeading>
        <Text>
          You agree not to use the Services (or allow your customers to use the
          Services) in any way or in connection with any transaction that would
          (or potentially would):
        </Text>
        <BulletPoint>
          Be considered a “Prohibited Use” or “Prohibited Business”, as further
          described and set forth in <b>Exhibit B</b>, attached hereto;
        </BulletPoint>
        <BulletPoint>
          Violate the terms for a Conditional Use or other provisions set forth
          in Section 3 of Exhibit B;
        </BulletPoint>
        <BulletPoint>
          Violate, misappropriate, or infringe the rights of RoundPe, our users,
          third parties, or others, including privacy, publicity, intellectual
          property, or other proprietary rights;
        </BulletPoint>
        <BulletPoint>
          Are illegal, defamatory, threatening, intimidating, or harassing;
        </BulletPoint>
        <BulletPoint>Involve impersonating someone;</BulletPoint>
        <BulletPoint>
          Breach any duty toward or rights of any person or entity, including
          rights of publicity, privacy, or trademark;
        </BulletPoint>
        <BulletPoint>
          Involve sending illegal or impermissible communications such as bulk
          messaging, auto-messaging, auto-dialing, and the like;
        </BulletPoint>
        <BulletPoint>
          Avoid, bypass, remove, deactivate, impair, descramble or otherwise
          circumvent any technological measure implemented by us or any of our
          service providers or any other third party (including another user) to
          protect the Services or Content;
        </BulletPoint>
        <BulletPoint>
          Disguise your location through IP proxying or other methods;
        </BulletPoint>
        <BulletPoint>
          Interfere with, or attempt to interfere with, the access of any user,
          host or network, including, without limitation, sending a virus,
          overloading, flooding, spamming, or mail-bombing the Services;
        </BulletPoint>
        <BulletPoint>
          Involve any unfair, deceptive or abusive act or practice;
        </BulletPoint>
        <BulletPoint>Violate any applicable law or regulation; or</BulletPoint>
        <BulletPoint>
          Knowingly encourage or enable any other individual to do any of the
          foregoing.
        </BulletPoint>
        <Text>
          Although we have no obligation to monitor any User Content, we have
          absolute discretion to remove User Content at any time and for any
          reason without notice. You understand that by using the Services, you
          may be exposed to User Content that is offensive, indecent, or
          objectionable. We take no responsibility and assume no liability for
          any User Content, including any loss or damage to any of your User
          Content.
        </Text>
        <Text>
          You agree to comply with all applicable U.K., Singapore, and other
          export control and trade sanctions laws (<b>“Export Laws”</b>).
          Without limiting the foregoing, you may not download the App or use
          the Services if (1) you are in, under the control of, or a national or
          resident of Cuba, Iran, North Korea, Sudan, or Syria or any other
          country subject to United States embargo, UN Security Council
          Resolutions (<b>“UNSCR”</b>), HM Treasury&apos;s financial sanctions
          regime, or if you are on the U.S. Treasury Department&apos;s Specially
          Designated Nationals List or the U.S. Commerce Department&apos;s
          Denied Persons List, Unverified List, Entity List HM Treasury&apos;s
          financial sanctions regime; or (2) you intend to supply any Services
          to Cuba, Iran, North Korea, Sudan or Syria or any other country
          subject to United States embargo or HM Treasury&apos;s financial
          sanctions regime (or a national or resident of one of these
          countries), or to a person on the Specially Designated Nationals List,
          Denied Persons List, Unverified List, Entity List, or HM
          Treasury&apos;s financial sanctions regime.
        </Text>
        <SubHeading>Termination</SubHeading>
        <Text>
          We may terminate or suspend your access to and use of the Services
          with immediate effect, at our sole discretion for any reason, at any
          time and without notice to you. You may cancel your Account at any
          time by following the account closure instructions in the App. Upon
          any termination, discontinuation or cancellation of Services or your
          Account, (i) all rights and/or licences granted to you under these
          Terms shall immediately cease and terminate and you shall forthwith
          cease the use and/or access of the App, Site, Services and Content in
          any way whatsoever; and (ii) notwithstanding the foregoing, the
          following provisions of these Terms will survive: Feedback, Content
          Ownership, Responsibility and Removal (save for the subsection “Rights
          in Content Granted by Round Finance Inc.” ), Termination, Warranty
          Disclaimers, Indemnity, Limitation of Liability, Dispute Resolution,
          and General Terms.
        </Text>
        <SubHeading>Warranty Disclaimers</SubHeading>
        <Text>
          YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE SERVICES
          (INCLUDING ANY PRIVATE KEY STORAGE SERVICE OFFERED AS PART OF THE
          SERVICES, WHETHER CLOUD OR HARDWARE-BASED) AND CONTENT IS AT YOUR SOLE
          RISK AND THAT THE ENTIRE RISK AS TO SATISFACTORY QUALITY, PERFORMANCE,
          ACCURACY AND EFFORT IS WITH YOU. THE APP, SITE AND SERVICES ARE
          PROVIDED ON AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS
          WITHOUT ANY REPRESENTATION OR WARRANTY, WHETHER EXPRESS, IMPLIED OR
          STATUTORY. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW,
          ROUNDPE’S SPECIFICALLY DISCLAIMS ANY EXPRESS OR IMPLIED WARRANTIES OF
          TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND/OR
          NON-INFRINGEMENT. ROUNDPE’S DOES NOT MAKE ANY REPRESENTATIONS OR
          WARRANTIES THAT ACCESS TO THE SERVICES OR ANY OF THE MATERIALS
          CONTAINED THEREIN WILL BE CONTINUOUS, UNINTERRUPTED, TIMELY, OR
          ERROR-FREE.
        </Text>
        <Text>
          <b>
            USE OF ANY PRIVATE KEY STORAGE SERVICE INCLUDED AS PART OF THE
            SERVICES IS OFFERED TO YOU AS A CONVENIENCE, SUBJECT TO THE
            LIMITATIONS ABOVE. TO BE SAFE, YOU SHOULD ALWAYS BACKUP YOUR PRIVATE
            ACCESS KEY VIA SECONDARY MEANS.
          </b>
        </Text>
        <SubHeading>Indemnity</SubHeading>
        <Text>
          You will indemnify and hold harmless RoundPe’s Holdings and its
          officers, directors, employees and agents from and against any claims,
          disputes, demands, liabilities, damages, losses, and costs and
          expenses, including, without limitation, reasonable legal and
          accounting fees arising out of or in any way connected with (i) your
          access to or use of the Services or Content, (ii) your User Content,
          (iii) Third Party Materials, or (iv) your violation of these Terms.
        </Text>
        <SubHeading>Limitation of Liability</SubHeading>
        <Text>
          TO THE MAXIMUM EXTENT NOT PROHIBITED BY LAW, ROUND FINANCE INC. SHALL
          NOT BE LIABLE FOR DAMAGES OF ANY TYPE, WHETHER DIRECT OR INDIRECT,
          ARISING OUT OF OR IN ANY WAY RELATED TO YOUR USE OR INABILITY TO USE
          THE SERVICES, INCLUDING BUT NOT LIMITED TO DAMAGES ALLEGEDLY ARISING
          FROM THE COMPROMISE OR LOSS OF YOUR LOGIN CREDENTIALS OR FUNDS, OR
          LOSS OF OR INABILITY TO RESTORE ACCESS FROM YOUR BACKUP PHRASE, OR FOR
          MISTAKES, OMISSIONS, INTERRUPTIONS, DELAYS, DEFECTS AND/OR ERRORS IN
          THE TRANSMISSION OF TRANSACTIONS OR MESSAGES TO THE ETHEREUM NETWORK,
          OR THE FAILURE OF ANY MESSAGE TO SEND TO OR BE RECEIVED BY THE
          INTENDED RECIPIENT IN THE INTENDED FORM, OR FOR DIMINUTION OF VALUE OF
          ETHER OR ANY OTHER DIGITAL TOKEN OR DIGITAL ASSET ON THE ETHEREUM
          NETWORK. ROUNDPE SHALL NOT BE LIABLE UNDER ANY CIRCUMSTANCES FOR ANY
          LOST PROFITS OR ANY SPECIAL, INCIDENTAL, INDIRECT, INTANGIBLE, OR
          CONSEQUENTIAL DAMAGES, WHETHER BASED IN CONTRACT, TORT, NEGLIGENCE,
          STRICT LIABILITY, OR OTHERWISE, ARISING OUT OF OR IN CONNECTION WITH
          AUTHORIZED OR UNAUTHORIZED USE OF THE SERVICES, EVEN IF AN AUTHORIZED
          REPRESENTATIVE OF ROUNDPE HAS BEEN ADVISED OF OR KNEW OR SHOULD HAVE
          KNOWN OF THE POSSIBILITY OF SUCH DAMAGES. ROUNDPE SHALL NOT BE LIABLE
          UNDER ANY CIRCUMSTANCES FOR DAMAGES ARISING OUT OF OR IN ANY WAY
          RELATED TO SOFTWARE, PRODUCTS, SERVICES, AND/OR INFORMATION OFFERED OR
          PROVIDED BY THIRD-PARTIES AND ACCESSED THROUGH THE APP, SITE OR
          SERVICES.
        </Text>
        <Text>
          SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OF LIABILITY FOR
          PERSONAL INJURY, OR OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THIS
          LIMITATION MAY NOT APPLY TO YOU. IN NO EVENT SHALL ROUNDPE’S TOTAL
          LIABILITY TO YOU FOR ALL DAMAGES (OTHER THAN AS MAY BE REQUIRED BY
          APPLICABLE LAW IN CASES INVOLVING PERSONAL INJURY) EXCEED THE AMOUNT
          OF ONE HUNDRED U.S. DOLLARS ($USD100.00) OR ITS EQUIVALENT IN THE
          LOCAL CURRENCY OF THE APPLICABLE JURISDICTION.
        </Text>
        <SubHeading>Dispute Resolution</SubHeading>
        <SubHeading>Governing Law, Forum and Venue</SubHeading>
        <Text>
          Notwithstanding your agreeing to comply with all applicable Export
          Laws, these Terms and any action related thereto will be governed by
          the laws of the state of California in the United States, without
          regard to its conflict of laws provisions, If you are a user located
          in the United States or Canada, the terms in the “Special Arbitration
          Provision for United States or Canada Users” section below apply to
          you.
        </Text>
        <Text>
          If you are not located in the United States or Canada, you agree that
          you will resolve any claim you have with us relating to, arising out
          of, or in any way in connection with our Terms, us, or our Services
          (each, a <b>“Dispute,”</b> and together, <b>“Disputes”</b>)
          exclusively in the state courts located in the City and County of San
          Francisco, California, or federal court for the Northern District of
          California, and you agree to submit to the personal jurisdiction of
          such courts for the purpose of litigating all such Disputes.
        </Text>
        <SubHeading>
          Special Arbitration Provision for United States or Canada Users
        </SubHeading>
        <Text>
          If you are a user located in the United States or Canada, you and
          RoundPe agree that any Dispute 
          <b>
            shall be finally settled in binding arbitration, on an individual
            basis, in accordance with the American Arbitration
            Association&apos;s rules for arbitration of consumer-related
            disputes (accessible at https://adr.org/Rules) and you and RoundPe
            hereby expressly waive trial by jury and right to participate in a
            class action lawsuit, private attorney general actions, or
            class-wide arbitration
          </b>
          , except that each party retains the right: (i) to bring an individual
          action in small claims court and (ii) to seek injunctive or other
          equitable relief in a court of competent jurisdiction to prevent the
          actual or threatened infringement, misappropriation or violation of a
          party’s copyrights, trademarks, trade secrets, patents or other
          intellectual property rights (the action described in the foregoing
          clause (ii), an <b>“IP Protection Action”</b>). The exclusive
          jurisdiction of an IP Protection Action shall be the courts of San
          Francisco, California and you agree to submit to the personal
          jurisdiction of such courts for the purpose of litigating IP
          Protection Actions.
        </Text>
        <Text>
          The Federal Arbitration Act, 9 U.S.C. §§ 1-16, fully applies to the
          arbitration. The arbitration will be conducted by a single, neutral
          arbitrator and shall take place in the county or, if applicable,
          parish in which you reside, or another mutually agreeable location, in
          the English language. The arbitrator may award any relief that a court
          of competent jurisdiction could award, including attorneys&apos; fees
          when authorized by law, and the arbitral decision may be entered as a
          judgement and enforced in any court of law. At your request, hearings
          may be conducted in person or by telephone and the arbitrator may
          provide for submitting and determining motions on briefs, without oral
          hearings. The prevailing party in any action or proceeding to enforce
          this agreement shall be entitled to costs and attorneys&apos; fees.
        </Text>
        <Text>
          If the arbitrator(s) or arbitration administrator would impose filing
          fees or other administrative costs on you, we will reimburse you, upon
          request, to the extent such fees or costs would exceed those that you
          would otherwise have to pay if you were proceeding instead in a court.
          We will also pay additional fees or costs if required to do so by the
          arbitration administrator&apos;s rules or applicable law. Apart from
          the foregoing, each Party will be responsible for any other fees or
          costs, such as attorney fees that the Party may incur. If a court
          decides that any provision of this Special Arbitration Provision is
          invalid or unenforceable, that provision shall be severed and the
          other parts of this Special Arbitration Provision shall still apply.
          In any case, the remainder of this User Agreement, will continue to
          apply.
        </Text>
        <SubHeading>General Terms</SubHeading>
        <Text>
          These Terms constitute the entire and exclusive understanding and
          agreement between RoundPe and you regarding the Services and Content,
          and these Terms supersede and replace any and all prior oral or
          written understandings or agreements between RoundPe and you regarding
          the Services and Content. If any provision of these Terms is held
          invalid or unenforceable (either by an arbitrator appointed pursuant
          to the terms of the “Special Arbitration Provision for United States
          or Canada Users” section above or by a court of competent
          jurisdiction, that provision will be enforced to the maximum extent
          permissible and the other provisions of these Terms will remain in
          full force and effect. You may not assign or transfer these Terms, by
          operation of law or otherwise, without our prior written consent. Any
          attempt by you to assign or transfer these Terms, without such
          consent, will be null. We may freely assign or transfer these Terms
          without restriction. Subject to the foregoing, these Terms will bind
          and inure to the benefit of the parties, their successors and
          permitted assigns.
        </Text>
        <Text>
          Any notices or other communications provided by us under these Terms,
          including those regarding modifications to these Terms, will be given
          by posting to the Services and/or through other electronic
          communication. You agree and consent to receive electronically all
          communications, agreements, documents, notices and disclosures
          (collectively,<b>&quot;Communications&quot;</b>) that we provide in
          connection with your Account and your use of the Services.
        </Text>
        <Text>
          <b>
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of such right or provision. The waiver of
            any such right or provision will be effective only if in writing and
            signed by a duly authorized representative of RoundPe. Except as
            expressly set forth in these Terms, the exercise by either party of
            any of its remedies under these Terms will be without prejudice to
            its other remedies under these Terms or otherwise.
          </b>
        </Text>
        <Text>
          <b>
            These Terms are written in English (U.S.). Any translated version is
            provided solely for your convenience. To the extent any translated
            version of our Terms conflicts with the English version, the English
            version controls.
          </b>
        </Text>
        <Text>
          Unless otherwise provided in these Terms, a person or entity who is
          not a party to these Terms shall have no right to enforce any term of
          these Terms, regardless of whether such person or entity has been
          identified by name, as a member of a class or as answering a
          particular description. For the avoidance of doubt, nothing in this
          provision shall affect the rights of any permitted assignee or
          transferee of these Terms.
        </Text>
        <SubHeading>Contact Information</SubHeading>
        <Text>
          If you have any questions about these Terms or the Services, please
          contact us at support@roundpe.com
        </Text>
        <SubHeading>EXHIBIT AFEE SCHEDULE</SubHeading>
        <Text>
          You shall pay RoundPe a one percent (1%) fee (<b>“Transaction Fee”</b>
          ), along with any applicable VAT or similar taxes on all transactions
          that occur using the RoundPe Application through which you accept
          certain blockchain-based digital currency, app coins, protocol tokens,
          or other digital currency from your customers (such transactions being{' '}
          <b>“Transactions”</b>). The pricing terms set forth herein are
          confidential and shall not be shared with any third parties.
        </Text>
        <InternalSubHeading>
          EXHIBIT BPROHIBITED USE AND PROHIBITED BUSINESSES
        </InternalSubHeading>
        <Text>
          This policy sets forth the limitations concerning your use of the
          Services.
        </Text>
        <BulletPoint>
          <b>PROHIBITED USE.</b> You may not use the Services to engage in the
          following categories of activity (<b>“Prohibited Uses”</b>). The
          Prohibited Uses extend to any third party that gains access to the
          Services through your account or otherwise, regardless of whether such
          third party was authorized or unauthorized by you to use the Services.
          The specific types of uses listed below are representative, but not
          exhaustive, of Prohibited Uses. By using the Services, you confirm
          that you will not use the Services to do any of the following:
          <BulletPoint>
            <b>Unlawful Activity:</b> Activity which would violate, or assist in
            violation of, any law, statute, ordinance, or regulation, sanctions
            programs administered in the countries where RoundPe conducts
            business, including, but not limited to, the U.S. Department of
            Treasury’s Office of Foreign Assets Control (<b>“OFAC”</b>), or
            which would involve proceeds of any unlawful activity; publish,
            distribute or disseminate any unlawful material or information.
          </BulletPoint>
          <BulletPoint>
            <b>Abusive Activity:</b> Actions which impose an unreasonable or
            disproportionately large load on our infrastructure, or
            detrimentally interfere with, intercept, or expropriate any system,
            data, or information; transmit or upload any material to the Site or
            App that contains viruses, Trojan horses, worms, or any other
            harmful or deleterious programs; attempt to gain unauthorized access
            to the Site or App, other accounts, computer systems or networks
            connected to the Site or App, through password mining or any other
            means; use account information of another party to access or use the
            Site or App; or transfer your account access or rights to your
            account to a third party, unless by operation of law or with the
            express permission of RoundPe.
          </BulletPoint>
          <BulletPoint>
            <b>Abuse Other Users:</b> Interfere with another of our user’s
            access to or use of any Services; defame, abuse, extort, harass,
            stalk, threaten or otherwise violate or infringe the legal rights
            (such as, but not limited to, rights of privacy, publicity and
            intellectual property) of others; harvest or otherwise collect
            information from the Site or App about others, including, without
            limitation, email addresses, without proper consent.
          </BulletPoint>
          <BulletPoint>
            <b>Fraud:</b> Activity which operates to defraud RoundPe, RoundPe’s
            users, or any other person; provide any false, inaccurate, or
            misleading information to RoundPe.
          </BulletPoint>
          <BulletPoint>
            <b>Gambling:</b> Lotteries; bidding fee auctions; sports forecasting
            or odds making; fantasy sports leagues with cash prizes; Internet
            gaming; contests; sweepstakes; games of chance.
          </BulletPoint>
          <BulletPoint>
            <b>Intellectual Property Infringement:</b> Engage in transactions
            involving items that infringe or violate any copyright, trademark,
            right of publicity or privacy or any other proprietary right under
            the law, including but not limited to sales, distribution, or access
            to counterfeit music, movies, software, or other licensed materials
            without the appropriate authorization from the rights holder; use of
            our or Round Finance Inc.’s intellectual property, name, or logo,
            including use of our or Round Finance Inc.’s trade or service marks,
            without express consent from RoundPe or Round Finance Inc.,
            respectively, or in a manner that otherwise harms RoundPe or Round
            Finance Inc. brand; any action that implies an untrue endorsement by
            or affiliation with RoundPe or Round Finance Inc.
          </BulletPoint>
          <BulletPoint>
            <b>Written Policies:</b> You may not use the Services in a manner
            that violates, or is otherwise inconsistent with, any operating
            instructions promulgated by RoundPe.
          </BulletPoint>
        </BulletPoint>
        <BulletPoint>
          <b>PROHIBITED BUSINESSES.</b> The following categories of businesses,
          business practices, and sale items are barred from the Services (
          <b>“Prohibited Businesses”</b>). The specific types of use listed
          below are representative, but not exhaustive, of Prohibited
          Businesses. If you are uncertain as to whether or not your use of the
          Services involves a Prohibited Business, or have questions about how
          these requirements apply to you or your customers, please contact us
          at support@roundpe.com. By opening an Account, you confirm that you or
          your customers will not use the Services in connection with any of
          following businesses, activities, practices, or items:
          <BulletPoint>
            <b>Restricted Financial Services:</b> Check cashing, bail bonds,
            collections agencies.
          </BulletPoint>
          <BulletPoint>
            <b>Intellectual Property or Proprietary Rights Infringement:</b>
             Sales, distribution, or access to counterfeit music, movies,
            software, or other licensed materials without the appropriate
            authorization from the rights holder.
          </BulletPoint>
          <BulletPoint>
            <b>Counterfeit or Unauthorized Goods:</b> Unauthorized sale or
            resale of brand name or designer products or services; sale of goods
            or services that are illegally imported or exported or which are
            stolen.
          </BulletPoint>
          <BulletPoint>
            <b>Regulated Products and Services:</b> Marijuana dispensaries and
            related businesses; sale of tobacco, e-cigarettes, and e-liquid;
            online prescription or pharmaceutical services; age-restricted goods
            or services; weapons and munitions; gunpowder and other explosives;
            fireworks and related goods; toxic, flammable, and radioactive
            materials; products and services with varying legal status on a
            state-by-state basis.
          </BulletPoint>
          <BulletPoint>
            <b>Drugs and Drug Paraphernalia:</b> Sale of narcotics, controlled
            substances, and any equipment designed for making or using drugs,
            such as bongs, vaporizers, and hookahs.
          </BulletPoint>
          <BulletPoint>
            <b>Pseudo-Pharmaceuticals:</b> Pharmaceuticals and other products
            that make health claims that have not been approved or verified by
            the applicable local and/or national regulatory body.
          </BulletPoint>
          <BulletPoint>
            <b> Substances designed to mimic illegal drugs:</b> Sale of a legal
            substance that provides the same effect as an illegal drug (e.g.,
            salvia, kratom).
          </BulletPoint>
          <BulletPoint>
            <b>Adult Content and Services:</b> Pornography (including
            literature, imagery and other media); sites offering any
            sexually-related services such as prostitution, escorts, pay-per
            view, or adult live chat features.
          </BulletPoint>
          <BulletPoint>
            <b>Multi-level Marketing:</b> Pyramid schemes, network marketing,
            and referral marketing programs.
          </BulletPoint>
          <BulletPoint>
            <b>Unfair, Predatory or Deceptive Practices:</b> Investment
            opportunities or other services that promise high rewards; sale or
            resale of a service without added benefit to the buyer; resale of
            government offerings without authorization or added value; sites
            that we determine in our sole discretion to be unfair, deceptive, or
            predatory towards consumers.
          </BulletPoint>
          <BulletPoint>
            <b>Gambling Services.</b>
          </BulletPoint>
          <BulletPoint>
            <b>Weapons Manufacturers/Vendors.</b>
          </BulletPoint>
          <BulletPoint>
            <b>Money Services:</b> Gift cards; prepaid cards; sale of in-game
            currency unless the merchant is the operator of the virtual world;
            act as a payment intermediary or aggregator or otherwise resell any
            of the Services.
          </BulletPoint>
          <BulletPoint>
            <b>Crowdfunding.</b>
          </BulletPoint>
          <BulletPoint>
            <b>High-risk Businesses:</b> any businesses that we believe pose
            elevated financial risk or legal liability.
          </BulletPoint>
        </BulletPoint>
        <BulletPoint>
          <b>CONDITIONAL USES.</b> Express written consent and approval from
          RoundPe on behalf of the Round Finance Inc’s entities must be obtained
          prior to using Services for the following categories of business
          and/or use (“Conditional Uses”). RoundPe may also require you to agree
          to additional conditions, make supplemental representations and
          warranties, complete enhanced on-boarding procedures, and operate
          subject to restrictions if you use the Services in connection with any
          of following businesses, activities, or practices:
          <BulletPoint>
            <b> Charities:</b> Acceptance of donations for nonprofit enterprise.
          </BulletPoint>
          <BulletPoint>
            <b>Games of Skill:</b> Games which are not defined as gambling under
            these Terms or by law, but which require an entry fee and award a
            prize.
          </BulletPoint>
          <BulletPoint>
            <b>Religious/Spiritual Organizations:</b> Operation of a for-profit
            religious or spiritual organization.
          </BulletPoint>
        </BulletPoint>
      </InnerContainer>
    </Container>
  );
};
